"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FilePreviewListRenderer {
    constructor(list, listitemTemplate, controller, fileNameFormatter, fileSizeFormatter, fileIdCreator) {
        this.list = list;
        this.listitemTemplate = listitemTemplate;
        this.controller = controller;
        this.fileNameFormatter = fileNameFormatter;
        this.fileSizeFormatter = fileSizeFormatter;
        this.fileIdCreator = fileIdCreator;
        this.fileNameTarget = '[data-js-file="filename"]';
        this.fileSizeTarget = '[data-js-file="filesize"]';
        this.removeButtonTarget = '[data-js-file="remove"]';
        this.listItemTarget = '[data-js-file="listitem"]';
        this.fileIdAttribute = 'data-js-file-id';
    }
    /**
     * Adds a file to the preview list.
     * @param {File} file - The file to be added.
     */
    add(file) {
        const [listItem, fileName, fileSize, removeButton] = this.getCloneTemplateElements();
        if (!(listItem && fileName && fileSize && removeButton)) {
            console.error("Failed to clone template elements for file preview list.");
            return;
        }
        listItem.setAttribute(this.fileIdAttribute, this.fileIdCreator.create(file));
        this.setFileInfo(file, fileName, fileSize);
        this.setupRemoveButton(file, removeButton);
        this.list.appendChild(listItem);
    }
    /**
     * Sets up the remove button for the file preview.
     * @param {File} file - The file associated with the remove button.
     * @param {HTMLButtonElement} removeButton - The button element to set up.
     */
    setupRemoveButton(file, removeButton) {
        removeButton.addEventListener('click', () => {
            this.controller.removeFileFromList(file);
        });
    }
    /**
     * Sets the file name and size in the preview.
     * @param {HTMLElement} fileName - The element to display the file name.
     * @param {HTMLElement} fileSize - The element to display the file size.
     */
    setFileInfo(file, fileName, fileSize) {
        fileName.textContent = this.fileNameFormatter.format(file.name);
        fileSize.textContent = this.fileSizeFormatter.format(file.size);
    }
    /**
     * Removes a file from the preview list.
     * @param {File} file - The file to be removed.
     */
    remove(file) {
        const items = this.list.querySelectorAll(this.listItemTarget);
        items.forEach((item) => {
            if (item.getAttribute(this.fileIdAttribute) === this.fileIdCreator.create(file)) {
                item.remove();
            }
        });
    }
    /**
     * Retrieves the cloned template elements for file preview.
     * @returns {HTMLElement[]} An array containing the cloned list item, file name, file size, and remove button.
     */
    getCloneTemplateElements() {
        const fragment = this.listitemTemplate.content.cloneNode(true);
        const listItem = fragment.firstElementChild;
        const fileName = listItem === null || listItem === void 0 ? void 0 : listItem.querySelector(this.fileNameTarget);
        const fileSize = listItem === null || listItem === void 0 ? void 0 : listItem.querySelector(this.fileSizeTarget);
        const removeButton = listItem === null || listItem === void 0 ? void 0 : listItem.querySelector(this.removeButtonTarget);
        return [listItem, fileName, fileSize, removeButton];
    }
}
exports.default = FilePreviewListRenderer;
